import React from 'react';
import * as LucideIcons from 'lucide-react';
import { services } from '../data/mock';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// Service background images
const getServiceImage = (serviceId) => {
  const images = {
    1: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085',
    2: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c',
    3: 'https://images.unsplash.com/photo-1610563166150-b34df4f3bcd6',
    4: 'https://images.pexels.com/photos/89955/pexels-photo-89955.jpeg',
    5: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0',
    6: 'https://images.unsplash.com/photo-1561070791-2526d30994b5',
    7: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee',
    8: 'https://images.unsplash.com/photo-1667984390535-6d03cff0b11a',
    9: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f',
    10: 'https://images.unsplash.com/photo-1455390582262-044cdead277a'
  };
  return images[serviceId] || images[1];
};

const Services = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center shadow-lg shadow-purple-500/50">
              <div className="w-4 h-4 bg-white rounded-sm"></div>
            </div>
            <span className="text-purple-400 font-semibold uppercase tracking-wider text-sm">
              SERVICES
            </span>
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4"
            style={{ letterSpacing: '0.1em' }}
          >
            Digital Solutions
          </h2>
          <div className="h-1 w-32 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto rounded-full"></div>
        </div>

        {/* Services Slider */}
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          autoplay={{ 
            delay: 3000, 
            disableOnInteraction: false,
            pauseOnMouseEnter: true 
          }}
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 }
          }}
          className="services-swiper"
        >
          {services.map((service) => {
            const Icon = LucideIcons[service.icon];
            return (
              <SwiperSlide key={service.id}>
                <Link to={service.link}>
                  <div className="group relative w-full aspect-square rounded-3xl overflow-hidden hover:scale-105 transition-all duration-300 hover:shadow-2xl hover:shadow-purple-500/30 cursor-pointer border border-purple-500/20">
                    {/* Background Image */}
                    <div className="absolute inset-0">
                      <img 
                        src={getServiceImage(service.id)} 
                        alt={service.title}
                        className="w-full h-full object-cover"
                      />
                      {/* Strong Dark Overlay for better text visibility */}
                      <div className="absolute inset-0 bg-gradient-to-br from-gray-900/90 via-black/85 to-gray-900/90"></div>
                    </div>
                    
                    {/* Hover gradient overlay */}
                    <div className="absolute inset-0 bg-gradient-to-br from-purple-600/30 via-blue-600/30 to-purple-600/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                    {/* Content */}
                    <div className="relative z-10 p-6 flex flex-col items-center justify-center text-center h-full space-y-4">
                      {/* Icon */}
                      <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-blue-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-purple-500/50">
                        {Icon && <Icon className="h-8 w-8 text-white" />}
                      </div>

                      {/* Title */}
                      <h3 className="text-white font-bold text-xl">{service.title}</h3>

                      {/* Features */}
                      <ul className="space-y-2">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="text-gray-300 text-sm">
                            {feature}
                          </li>
                        ))}
                      </ul>

                      {/* Arrow Icon */}
                      <div className="pt-2">
                        <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-blue-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-all shadow-lg shadow-purple-500/50">
                          <ArrowRight className="h-5 w-5 text-white group-hover:translate-x-1 transition-transform" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default Services;